import React from 'react';
import { SubSkillProgress, ModuleId } from '../../types';
import { LevelLadder } from './LevelLadder';
interface GrowthProgressProps {
  moduleId: ModuleId;
  subSkills: Record<string, SubSkillProgress>;
}
/**
 * GrowthProgress v2 - Now wraps LevelLadder for backwards compatibility.
 * Shows the level progression ladder (B6→B6+→M6→...) instead of the old
 * colored subSkill cards. All existing imports continue to work.
 */
export function GrowthProgress({
  moduleId,
  subSkills
}: GrowthProgressProps) {
  return <LevelLadder moduleId={moduleId} subSkills={subSkills} data-id="element-330" />;
}